import React from "react";
import NotFound from "./NotFound/NotFound";
import ServerError from "./ServerError/ServerError";
import constants from "../../utils/constants";
import classnames from "classnames";
import styles from "./ErrorScreen.scss";
import { redirectUrl } from "../../utils/misc";

function ErrorScreen({ type, showDesktopLogo, showMobileLogo, logos, hotelSiteURL }) {
  const handleBackButton = () => {
    if (hotelSiteURL) {
      redirectUrl(hotelSiteURL);
    } else if (document.referrer) {
      redirectUrl(document.referrer);
    }
  };

  let Element = null;

  switch (type) {
    case constants.ERROR_SCREEN.NOT_FOUND:
      Element = <NotFound hotelSiteURL={hotelSiteURL} handleBackButton={handleBackButton} />;
      break;

    case constants.ERROR_SCREEN.SERVER:
      Element = <ServerError hotelSiteURL={hotelSiteURL} handleBackButton={handleBackButton} />;
      break;

    default:
      break;
  }

  const hasLogo =
    logos &&
    ((showDesktopLogo && logos.get("logo") && logos.get("logo").get("url")) ||
      (showMobileLogo && logos.get("logoMobile") && logos.get("logoMobile").get("url")));

  return (
    <div
      className={classnames(
        "wbkv9-ErrorScreen-container",
        hasLogo && styles.hasLogo,
        styles.container
      )}>
      {hasLogo && (
        <div className={classnames("wbkv9-ErrorScreen-header", styles.header)}>
          <div
            id="wbkv9-App-BookingFormLogo"
            className={classnames("wbkv9-ErrorScreen-BookingFormLogo", styles.BookingFormLogo)}>
            {showDesktopLogo && (
              <div
                className={classnames(
                  "wbkv9-ErrorScreen-desktopLogoContainer",
                  styles.desktopLogoContainer
                )}>
                {logos && logos.get("logo") && logos.get("logo").get("url") && (
                  <a href={hotelSiteURL} target="_blank">
                    <img src={logos.get("logo").get("url")} />
                  </a>
                )}
              </div>
            )}

            {showMobileLogo && (
              <div
                className={classnames(
                  "wbkv9-ErrorScreen-mobileLogoContainer",
                  styles.mobileLogoContainer
                )}>
                {logos && logos.get("logoMobile") && logos.get("logoMobile").get("url") && (
                  <a href={hotelSiteURL} target="_blank">
                    <img src={logos.get("logoMobile").get("url")} />
                  </a>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      {Element}
    </div>
  );
}

export default ErrorScreen;
